import api from './api';

const questionService = {
  // Get all questions with pagination
  getQuestions: async (page = 1, limit = 10) => {
    return api.get(
      `/questions?page=${page}&limit=${limit}`
    );
  },

  // Alias for backward compatibility
  getAllQuestions: async (page = 1, limit = 10) => {
    return api.get(
      `/questions?page=${page}&limit=${limit}`
    );
  },

  // Get a question by ID
  getQuestion: async (id) => {
    return api.get(`/questions/${id}`);
  },

  // Alias for getQuestion
  getQuestionById: async (id) => {
    return api.get(`/questions/${id}`);
  },

  // Create a new question
  createQuestion: async (questionData) => {
    return api.post(`/questions`, questionData);
  },

  // Update a question
  updateQuestion: async (id, questionData) => {
    return api.put(`/questions/${id}`, questionData);
  },

  // Delete a question
  deleteQuestion: async (id) => {
    return api.delete(`/questions/${id}`);
  },

  // Get today's active question
  getTodayQuestion: async () => {
    return api.get(`/questions/today/active`);
  },
};

export default questionService;
